import { VendorHub } from 'scenes/vendorHub';

export const SupplierHubContainer = () => <VendorHub context="external" />;
